module.exports = __webpack_public_path__ + "static/media/tanishq2.6e4b6734.jpg";